const grade = {
  state: {
    tableTypeW: 52,
    gradeList: [],
    position: 0,
    setGames: {}
  },
  getters: {

  },
  mutations: {
    upGradeList (state, data) {
      state.gradeList = data
    },
    SAVE_POSITION (state, data) {
      state.position = data
    },
    getGames (state, data) {
      state.setGames = data
    }
  },
  actions: {
    getGradeList ({commit}, data) {
      commit('upGradeList', data)
    }
  }
}

export default grade



// WEBPACK FOOTER //
// ./src/store/modules/grade.js